var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7345 27.2388H26.3347L29.8016 30.6575V32.3669L27.2014 34.9309V35.7856L26.3347 36.6402V38.3496L25.4679 39.2043L23.7345 37.4949V32.3669L22.001 30.6575V28.9482L23.7345 27.2388Z",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2002 16.5992V18.6921L15.0669 19.5467V20.4014L14.2002 21.2561V22.9665L15.0669 23.8201H16.8004L19.4006 27.2388H20.2674L21.1341 26.3841V25.5305L22.8676 23.8201H24.6011V22.1108L26.3345 20.4014H28.068V16.9827L25.4678 14.4187L23.7343 16.128L20.2674 12.7094",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0887 37.5024C49.7366 37.1744 47.028 24.4077 41.5567 18.3716C38.5871 25.7966 33.5394 26.3842 35.274 35.3582",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0026 28.6746C40.2681 36.4981 33.5942 42.6229 25.4685 42.6229C16.852 42.6229 9.86719 35.7353 9.86719 27.2387C9.86719 18.7422 16.852 11.8546 25.4685 11.8546C30.4793 11.8546 34.9387 14.1836 37.7924 17.8042",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6993 39.3474C43.358 40.5589 42.8834 42.3815 43.4891 44.1464C41.2507 43.952 37.7285 43.9274 38.0644 40.6187",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 34,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSustainability);
export default __webpack_public_path__ + "static/media/icon_sustainability.98c4cf84371acb4bc87e5699c1d88983.svg";
export { ForwardRef as ReactComponent };